<template>
  <div class="activities-container">
    <v-layout row wrap>
      <v-flex
        v-for="inventory in paymentTrue"
        :key="inventory.public_id"
        align-content-space-between
        md4
        xs12
      >
        <v-container fluid>
          <v-card flat hover class="activity-card elevation-2">
            <v-img
              :src="inventory.thumbnail"
              aspect-ratio="1.5"
              class="activity-image"
              gradient="to bottom, rgba(0,0,0,0.1), rgba(0,0,0,0.3)"
            >
              <v-container fill-height class="pa-0">
                <v-layout align-end class="image-overlay">
                  <v-flex xs12>
                    <span
                      v-if="inventory.pricing_status === 'true'"
                      class="activity-badge"
                    >
                      {{ $localCurrency }}
                      {{ $roundOff(convert1(inventory.price.currency_type, inventory.price.child_price).amount) }}
                      per child /
                      {{ $localCurrency }}
                      {{ $roundOff(convert1(inventory.price.currency_type, inventory.price.adult_price).amount) }}
                      per adult
                    </span>
                    <span v-if="inventory.note" class="activity-note">
                      {{ inventory.note }}
                    </span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-img>

            <v-container fluid class="pt-3 pb-0">
              <h3 class="activity-title earthwerk-font">
                {{ inventory.name.toUpperCase() }}
              </h3>

              <div class="capacity-display">
                <div class="capacity-item">
                  <v-icon small color="grey">people</v-icon>
                  <span class="capacity-label">Maximum Capacity:</span>
                  <span class="capacity-value">{{ inventory.maximum_guests || 10 }} Guests</span>
                </div>
              </div>

              <v-icon small class="info-icon" @click="openInfo(inventory)">
                info_outline
              </v-icon>

              <v-btn
                large
                dark
                color="primary"
                class="book-now-btn earthwerk-font mt-3"
                :disabled="inventory.pricing_status !== 'true'"
                @click="openBookingDialog(inventory)"
              >
                Add to Booking
              </v-btn>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>

    <v-layout v-if="!paymentTrue || paymentTrue.length === 0" row wrap>
      <v-flex v-for="n in 3" :key="n" lg4 md12 xs12 sm12>
        <v-container fluid class="pa-2">
          <v-card class="elevation-2">
            <v-container>
              <content-placeholders :rounded="true">
                <content-placeholders-img />
                <content-placeholders-heading />
              </content-placeholders>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>

    <v-dialog v-model="infoDialog" persistent max-width="900px">
      <v-card class="info-dialog">
        <div class="gallery-section">
          <div v-if="infoImages && infoImages.length" class="gallery-container">
            <div class="image-navigation">
              <button
                class="nav-button prev"
                :disabled="currentInfoImageIndex === 0"
                @click="prevInfoImage"
              >
                <v-icon>chevron_left</v-icon>
              </button>
              <div class="image-wrapper">
                <img
                  :src="infoImages[currentInfoImageIndex].path"
                  class="gallery-image"
                  alt="Activity image"
                />
              </div>
              <button
                class="nav-button next"
                :disabled="currentInfoImageIndex === infoImages.length - 1"
                @click="nextInfoImage"
              >
                <v-icon>chevron_right</v-icon>
              </button>
            </div>
            <div class="image-counter">
              {{ currentInfoImageIndex + 1 }} / {{ infoImages.length }}
            </div>
          </div>
          <div v-else class="single-image-container">
            <img
              :src="currentInfoInventory ? currentInfoInventory.thumbnail : ''"
              class="gallery-image"
              alt="Activity thumbnail"
            />
          </div>
        </div>

        <v-card-text class="details-section">
          <div class="details-header">
            <h1 class="activity-title earthwerk-font">
              {{ currentInfoInventory ? currentInfoInventory.name.toUpperCase() : '' }}
            </h1>
            <div class="capacity-display">
              <div class="capacity-item">
                <span class="capacity-label">Maximum Capacity:</span>
                <span class="capacity-value">
                  {{ currentInfoInventory ? currentInfoInventory.maximum_guests || 10 : '' }} Guests
                </span>
              </div>
            </div>
          </div>
          <div
            class="description-section"
            v-html="currentInfoInventory ? currentInfoInventory.description : ''"
          />
        </v-card-text>

        <v-card-actions class="dialog-actions">
          <v-spacer />
          <v-btn flat class="earthwerk-font" @click="infoDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" persistent scrollable max-width="900px">
      <v-card class="booking-dialog">
        <v-card-title class="dialog-header">
          <h2 class="earthwerk-font">ADD TO BOOKING</h2>
          <v-spacer />
          <v-chip
            v-if="selectedInventory"
            small
            color="white"
            text-color="#74a533"
            class="progress-chip"
          >
            {{ completedFields }} / {{ totalRequiredFields }} complete
          </v-chip>
        </v-card-title>

        <v-card-text class="dialog-content" style="max-height: 70vh; overflow-y: auto">
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12>
                <v-dialog
                  ref="dialog4"
                  v-model="modal3"
                  persistent
                  lazy
                  full-width
                  width="290px"
                  :return-value.sync="activity.activity_date"
                >
                  <v-text-field
                    slot="activator"
                    v-model="activity.activity_date"
                    label="Activity Date *"
                    prepend-icon="event"
                    class="date-input"
                    readonly
                    required
                  />
                  <v-date-picker
                    v-model="activity.activity_date"
                    scrollable
                    :min="minActivityDate"
                    :max="maxActivityDate"
                  >
                    <v-spacer />
                    <v-btn flat color="primary" @click="modal3 = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      flat
                      color="primary"
                      @click="$refs.dialog4.save(activity.activity_date)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>

              <v-flex v-if="showDates && activity.activity_date" xs12>
                <h4 class="earth-color" style="margin: 10px 0">
                  AVAILABLE SLOTS : {{ Number(activitySlots) }}
                </h4>
                <v-divider />
              </v-flex>

              <template v-if="selectedInventory && !selectedInventory.ranger_marker">
                <v-flex xs12 sm6>
                  <v-autocomplete
                    v-model="activity.adults"
                    label="Adults"
                    :items="adultSlots_"
                    prepend-icon="person"
                    class="participant-input"
                    :disabled="!activity.activity_date"
                    no-data-text="No Slots Available"
                  />
                </v-flex>

                <v-flex v-if="activity.adults > 0" xs12 sm6>
                  <v-autocomplete
                    v-model="activity.residency_adult"
                    data-field="residency-adult"
                    label="Residency Adult"
                    :items="allAdultConservationFees"
                    :loading="$loadingTrue"
                    item-text="payment_person"
                    item-value="payment_public_id"
                    prepend-icon="location_city"
                    hint="Select where this guest is a resident — this affects conservation fees"
                    persistent-hint
                    :return-object="true"
                  />
                </v-flex>

                <v-flex xs12 sm6>
                  <v-autocomplete
                    v-model="activity.children"
                    label="Children"
                    :items="childSlots_"
                    prepend-icon="child_friendly"
                    class="participant-input"
                    :disabled="!activity.activity_date"
                    no-data-text="No Slots Available"
                  />
                </v-flex>

                <v-flex v-if="activity.children > 0" xs12 sm6>
                  <v-autocomplete
                    v-model="activity.residency_children"
                    data-field="residency-children"
                    label="Residency Children"
                    :items="allChildrenConservationFees"
                    :loading="$loadingTrue"
                    item-text="payment_person"
                    item-value="payment_public_id"
                    prepend-icon="location_city"
                    hint="Select where this child is a resident — this affects conservation fees"
                    persistent-hint
                    :return-object="true"
                  />
                </v-flex>
              </template>

              <template v-if="selectedInventory && selectedInventory.ranger_marker">
                <v-flex xs12 sm6>
                  <v-autocomplete
                    v-model="activity.adults"
                    label="No of Rangers"
                    :items="adultSlots_"
                    prepend-icon="security"
                    class="participant-input"
                    :disabled="!activity.activity_date"
                    no-data-text="No Slots Available"
                  />
                </v-flex>

                <v-flex v-if="activity.adults > 0" xs12 sm6>
                  <v-autocomplete
                    v-model="activity.residency_adult"
                    data-field="residency-adult"
                    label="Residency Adult"
                    :items="allAdultConservationFees"
                    :loading="$loadingTrue"
                    item-text="payment_person"
                    item-value="payment_public_id"
                    prepend-icon="location_city"
                    hint="Select where this ranger is a resident — this affects conservation fees"
                    persistent-hint
                    :return-object="true"
                  />
                </v-flex>
              </template>

              <template
                v-if="
                  selectedInventory &&
                  selectedInventory.has_extras &&
                  !selectedInventory.ranger_marker
                "
              >
                <v-flex xs12>
                  <v-divider class="my-3" />
                  <h4 class="earth-color">Extra Participants</h4>
                </v-flex>

                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="activity.extra_pax_adults"
                    label="Extra Adults"
                    type="number"
                    min="0"
                    prepend-icon="person_add"
                  />
                </v-flex>

                <v-flex v-if="activity.extra_pax_adults > 0" xs12 sm6>
                  <v-autocomplete
                    v-model="activity.residency_extra_adult"
                    data-field="residency-extra-adult"
                    label="Residency Extra Adult"
                    :items="allAdultConservationFees"
                    :loading="$loadingTrue"
                    item-text="payment_person"
                    item-value="payment_public_id"
                    prepend-icon="location_city"
                    hint="Select where this guest is a resident"
                    persistent-hint
                    :return-object="true"
                  />
                </v-flex>

                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="activity.extra_pax_children"
                    label="Extra Children"
                    type="number"
                    min="0"
                    prepend-icon="child_care"
                  />
                </v-flex>

                <v-flex v-if="activity.extra_pax_children > 0" xs12 sm6>
                  <v-autocomplete
                    v-model="activity.residency_extra_children"
                    data-field="residency-extra-children"
                    label="Residency Extra Children"
                    :items="allChildrenConservationFees"
                    :loading="$loadingTrue"
                    item-text="payment_person"
                    item-value="payment_public_id"
                    prepend-icon="location_city"
                    hint="Select where this child is a resident"
                    persistent-hint
                    :return-object="true"
                  />
                </v-flex>
              </template>

              <template
                v-if="
                  selectedInventory &&
                  selectedInventory.public_id === '648f6bc6-96bd-446c-89c5-e988749bcdf7'
                "
              >
                <v-flex xs12 sm6>
                  <v-select
                    v-model="activity.time_frame"
                    :items="['7:00 PM', '9:00 PM']"
                    label="Select Preferred Time"
                    prepend-icon="access_time"
                  />
                </v-flex>
              </template>

              <template v-if="selectedInventory && needsPickupLocation">
                <v-flex xs12 sm6>
                  <v-select
                    v-model="activity.pick_up_location"
                    data-field="pick-up-location"
                    :items="allPickUpLocations"
                    label="Select Pick Up Location"
                    item-text="location_name"
                    item-value="location_public_id"
                    prepend-icon="location_on"
                    hint="We'll collect you here on the day of the activity"
                    persistent-hint
                  />
                </v-flex>
              </template>

              <v-flex v-if="hasParticipants" xs12>
                <div class="price-summary">
                  <h3 class="earthwerk-font">Price Summary</h3>
                  <div class="price-breakdown">
                    <template v-if="selectedInventory && !selectedInventory.ranger_marker">
                      <div v-if="activity.adults > 0" class="price-line">
                        <span>
                          {{ getResidencyName(activity.residency_adult) }} Adults
                          ({{ activity.adults }} × {{ $localCurrency }} {{ getAdultPrice }})
                        </span>
                        <span>{{ $localCurrency }} {{ calculateAdultTotal }}</span>
                      </div>
                      <div v-if="activity.children > 0" class="price-line">
                        <span>
                          {{ getResidencyName(activity.residency_children) }} Children
                          ({{ activity.children }} × {{ $localCurrency }} {{ getChildPrice }})
                        </span>
                        <span>{{ $localCurrency }} {{ calculateChildTotal }}</span>
                      </div>
                      <div v-if="activity.extra_pax_adults > 0" class="price-line">
                        <span>
                          {{ getResidencyName(activity.residency_extra_adult) }} Extra Adults
                          ({{ activity.extra_pax_adults }} × {{ $localCurrency }} {{ getAdultPrice }})
                        </span>
                        <span>{{ $localCurrency }} {{ calculateExtraAdultTotal }}</span>
                      </div>
                      <div v-if="activity.extra_pax_children > 0" class="price-line">
                        <span>
                          {{ getResidencyName(activity.residency_extra_children) }} Extra Children
                          ({{ activity.extra_pax_children }} × {{ $localCurrency }} {{ getChildPrice }})
                        </span>
                        <span>{{ $localCurrency }} {{ calculateExtraChildTotal }}</span>
                      </div>
                    </template>

                    <template v-if="selectedInventory && selectedInventory.ranger_marker">
                      <div v-if="activity.adults > 0" class="price-line">
                        <span>
                          {{ getResidencyName(activity.residency_adult) }} Rangers
                          ({{ activity.adults }} × {{ $localCurrency }} {{ getAdultPrice }})
                        </span>
                        <span>{{ $localCurrency }} {{ calculateAdultTotal }}</span>
                      </div>
                    </template>

                    <div class="price-total">
                      <strong>Total Amount:</strong>
                      <strong>{{ $localCurrency }} {{ calculateTotalPrice }}</strong>
                    </div>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions class="dialog-actions">
          <v-spacer />
          <v-btn flat class="cancel-btn earthwerk-font" @click="closeDialog">
            Cancel
          </v-btn>

          <v-tooltip left :disabled="isFormValid" content-class="warning-tooltip">
            <template v-slot:activator="{ on }">
              <div v-on="on" style="display: inline-block;">
                <v-btn
                  color="primary"
                  class="reserve-btn earthwerk-font"
                  :disabled="isSubmitBlocked"
                  @click="addToReservationCart"
                >
                  Add to Booking
                </v-btn>
              </div>
            </template>
            <span>{{ disabledReason }}</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'Activities',
  data() {
    return {
      dialog: false,
      infoDialog: false,
      currentInfoInventory: null,
      currentInfoImageIndex: 0,
      modal3: false,
      start_date: this.$moment().format('YYYY-MM-DD'),
      showDates: false,
      selectedInventory: null,
      route: this.$route ? this.$route.name : 'Index',
      activity: {
        activity_date: '',
        children: 0,
        adults: 0,
        extra_pax_adults: 0,
        extra_pax_children: 0,
        inventory: {},
        time_frame: '',
        pick_up_location: '',
        residency_adult: {},
        residency_children: {},
        residency_extra_adult: {},
        residency_extra_children: {},
      },
    }
  },
  created() {
    this.$store.dispatch('get_active_activities')
    this.$store.dispatch('get_all_pick_up_locations')
    this.$store.dispatch('get_all_gates')
    this.$store.dispatch('get_full_conservation_fees')

    this.loadActivityDateFromGlobalStore()
    this.loadGuestsFromStorage()
    this.$root.$on('booking-dates-changed', this.onBookingDatesChanged)
  },
  beforeDestroy() {
    this.$root.$off('booking-dates-changed', this.onBookingDatesChanged)
  },
  computed: {
    globalBookingDates() {
      if (this.$store.state.GlobalBookingStore && this.$store.state.GlobalBookingStore.booking_dates) {
        return this.$store.state.GlobalBookingStore.booking_dates
      }
      return null
    },
    hasGlobalBookingDates() {
      return this.globalBookingDates &&
             this.globalBookingDates.check_in &&
             this.globalBookingDates.check_in !== '' &&
             this.globalBookingDates.check_out &&
             this.globalBookingDates.check_out !== ''
    },
    formattedGlobalCheckIn() {
      if (!this.hasGlobalBookingDates) return ''
      return this.$moment(this.globalBookingDates.check_in).format('MMM DD, YYYY')
    },
    formattedGlobalCheckOut() {
      if (!this.hasGlobalBookingDates) return ''
      return this.$moment(this.globalBookingDates.check_out).format('MMM DD, YYYY')
    },
    globalBookingDays() {
      return this.globalBookingDates ? this.globalBookingDates.days : 0
    },
    minActivityDate() {
      if (this.hasGlobalBookingDates) {
        return this.globalBookingDates.check_in
      }
      return this.start_date
    },
    maxActivityDate() {
      if (this.hasGlobalBookingDates) {
        return this.$moment(this.globalBookingDates.check_out).subtract(1, 'days').format('YYYY-MM-DD')
      }
      return null
    },

    globalGuests() {
      if (this.$store.state.GlobalBookingStore && this.$store.state.GlobalBookingStore.booking_guests) {
        return this.$store.state.GlobalBookingStore.booking_guests
      }
      return { adults: 0, children: 0, total: 0 }
    },
    hasGlobalGuests() {
      return this.globalGuests.total > 0
    },
    formattedGlobalGuests() {
      if (!this.hasGlobalGuests) return ''
      return `${this.globalGuests.adults} Adult${this.globalGuests.adults !== 1 ? 's' : ''} and ${this.globalGuests.children} Child${this.globalGuests.children !== 1 ? 'ren' : ''}`
    },

    paymentTrue() {
      const activeInventory = []
      const allActivities = this.allActivities || []
      for (var i = 0; i < allActivities.length; i++) {
        var data = allActivities[i]
        if (data.pricing_status === 'true' && data.thumbnail !== null) {
          activeInventory.push(data)
        }
      }
      return activeInventory
    },
    allActivities() {
      return this.$store.state.ActivityStore ? this.$store.state.ActivityStore.active_activities || [] : []
    },
    allGates() {
      return this.$store.state.GateStore ? this.$store.state.GateStore.all_gates || [] : []
    },

    infoImages() {
      return this.$store.state.ActivityStore ? this.$store.state.ActivityStore.activity_images || [] : []
    },

    allPickUpLocations() {
      if (this.$store.state.PickUpLocationStore && this.$store.state.PickUpLocationStore.all_pick_up_locations) {
        return this.$store.state.PickUpLocationStore.all_pick_up_locations
      }
      return []
    },

    conservationFeesRaw() {
      if (this.$store.state.ConservationFeeStore) {
        return this.$store.state.ConservationFeeStore.conservation_fees || []
      }
      return []
    },

    needsPickupLocation() {
      return (
        this.selectedInventory &&
        (this.selectedInventory.public_id === '648f6bc6-96bd-446c-89c5-e988749bcdf7' ||
          this.selectedInventory.public_id === '4b45eed6-d1dd-4301-acb5-eca2a682d7c6' ||
          this.selectedInventory.public_id === '66e52cab-43cd-4974-85de-246a731d6905')
      )
    },
    childSlots_() {
      const slots = []
      const available = this.calculateChildMax_
      for (var i = 0; i <= available; i++) {
        slots.push(i)
      }
      return slots
    },
    adultSlots_() {
      const slots = []
      const available = this.calculateAdultMax_
      for (var i = 0; i <= available; i++) {
        slots.push(i)
      }
      return slots
    },
    calculateAdultMax_() {
      return Number(this.activitySlots) - Number(this.total) + Number(this.activity.adults)
    },
    calculateChildMax_() {
      return Number(this.activitySlots) - Number(this.total) + Number(this.activity.children)
    },
    totalParticipants() {
      return Number(this.activity.adults) + Number(this.activity.children) +
        Number(this.activity.extra_pax_adults) + Number(this.activity.extra_pax_children)
    },
    total() {
      return Number(this.activity.adults) + Number(this.activity.children)
    },
    activitySlots() {
  if (this.$store.state.BookingStore) {
    const slots = Number(this.$store.state.BookingStore.activity_slots)
    return slots > 0 ? slots : 0
  }
  return 0
},

    getAdultPrice() {
      if (!this.selectedInventory || !this.selectedInventory.price) return 0
      return this.$roundOff(
        this.convert1(
          this.selectedInventory.price.currency_type,
          this.selectedInventory.price.adult_price
        ).amount
      )
    },
    getChildPrice() {
      if (!this.selectedInventory || !this.selectedInventory.price) return 0
      return this.$roundOff(
        this.convert1(
          this.selectedInventory.price.currency_type,
          this.selectedInventory.price.child_price
        ).amount
      )
    },
    calculateAdultTotal() {
      if (!this.selectedInventory || !this.selectedInventory.price) return 0
      const baseTotal = this.activity.adults * this.selectedInventory.price.adult_price
      return this.$roundOff(
        this.convert1(this.selectedInventory.price.currency_type, baseTotal).amount
      )
    },
    calculateChildTotal() {
      if (!this.selectedInventory || !this.selectedInventory.price) return 0
      const baseTotal = this.activity.children * this.selectedInventory.price.child_price
      return this.$roundOff(
        this.convert1(this.selectedInventory.price.currency_type, baseTotal).amount
      )
    },
    calculateExtraAdultTotal() {
      if (!this.selectedInventory || !this.selectedInventory.price) return 0
      const baseTotal = this.activity.extra_pax_adults * this.selectedInventory.price.adult_price
      return this.$roundOff(
        this.convert1(this.selectedInventory.price.currency_type, baseTotal).amount
      )
    },
    calculateExtraChildTotal() {
      if (!this.selectedInventory || !this.selectedInventory.price) return 0
      const baseTotal = this.activity.extra_pax_children * this.selectedInventory.price.child_price
      return this.$roundOff(
        this.convert1(this.selectedInventory.price.currency_type, baseTotal).amount
      )
    },
    calculateTotalPrice() {
      if (!this.selectedInventory || !this.selectedInventory.price) return 0
      let total = 0
      if (!this.selectedInventory.ranger_marker) {
        total = this.activity.adults * this.selectedInventory.price.adult_price +
          this.activity.children * this.selectedInventory.price.child_price +
          this.activity.extra_pax_adults * this.selectedInventory.price.adult_price +
          this.activity.extra_pax_children * this.selectedInventory.price.child_price
      } else {
        total = this.activity.adults * this.selectedInventory.price.adult_price
      }
      return this.$roundOff(
        this.convert1(this.selectedInventory.price.currency_type, total).amount
      )
    },
    hasParticipants() {
      return this.activity.adults > 0 || this.activity.children > 0 ||
        this.activity.extra_pax_adults > 0 || this.activity.extra_pax_children > 0
    },
    isFormValid() {
      if (!this.activity.activity_date) return false
      if (this.activity.adults === 0 && this.activity.children === 0 &&
          this.activity.extra_pax_adults === 0 && this.activity.extra_pax_children === 0) return false

      if (this.activity.adults > 0 && !this.hasResidency(this.activity.residency_adult)) return false
      if (this.activity.children > 0 && !this.hasResidency(this.activity.residency_children)) return false
      if (this.activity.extra_pax_adults > 0 && !this.hasResidency(this.activity.residency_extra_adult)) return false
      if (this.activity.extra_pax_children > 0 && !this.hasResidency(this.activity.residency_extra_children)) return false

      if (this.needsPickupLocation && !this.activity.pick_up_location) return false

      return true
    },

    isSubmitBlocked() {
      return !this.activity.activity_date && !this.hasParticipants
    },

    disabledReason() {
      const err = this.getFirstValidationError()
      return err ? err.message : ''
    },

    completedFields() {
      let done = 0
      if (this.activity.activity_date) done++
      if (this.hasParticipants) done++
      if (this.activity.adults === 0 || this.hasResidency(this.activity.residency_adult)) done++
      if (this.activity.children === 0 || this.hasResidency(this.activity.residency_children)) done++
      if (this.activity.extra_pax_adults === 0 || this.hasResidency(this.activity.residency_extra_adult)) done++
      if (this.activity.extra_pax_children === 0 || this.hasResidency(this.activity.residency_extra_children)) done++
      if (!this.needsPickupLocation || this.activity.pick_up_location) done++
      return done
    },
    totalRequiredFields() {
      return this.needsPickupLocation ? 7 : 6
    },
  },
  watch: {
    'activity.activity_date'(newVal, oldVal) {
      if (newVal && newVal !== oldVal && this.selectedInventory) {
        this.findAvailability()
      }
    },
    activitySlots(newVal) {
      const available = Number(newVal) || 0
      if (available === 0) {
        this.activity.adults = 0
        this.activity.children = 0
        this.activity.extra_pax_adults = 0
        this.activity.extra_pax_children = 0
        return
      }
      let remaining = available
      if (this.activity.extra_pax_adults > remaining) {
        this.activity.extra_pax_adults = remaining
      }
      remaining -= Number(this.activity.extra_pax_adults)
      if (this.activity.extra_pax_children > remaining) {
        this.activity.extra_pax_children = remaining
      }
      remaining -= Number(this.activity.extra_pax_children)
      if (this.activity.adults > remaining) {
        this.activity.adults = remaining
      }
      remaining -= Number(this.activity.adults)
      if (this.activity.children > remaining) {
        this.activity.children = remaining
      }
    },
  },
  methods: {
    hasResidency(val) {
      return val && Object.keys(val).length > 0
    },

    loadActivityDateFromGlobalStore() {
      if (this.hasGlobalBookingDates) {
        this.activity.activity_date = this.globalBookingDates.check_in
      }
    },

    getStorageAdults() {
      try {
        const guests = JSON.parse(localStorage.getItem('guests') || '{}')
        if (guests.adults !== undefined && guests.adults !== null && guests.adults !== '') {
          return Number(guests.adults || 0)
        }
      } catch (e) {}

      try {
        const conservation = JSON.parse(localStorage.getItem('conservation_data') || '[]')
        if (Array.isArray(conservation) && conservation.length > 0) {
          return conservation.reduce(function (sum, fee) {
            const type = fee.payment_person ? fee.payment_person.toLowerCase() : ''
            if (type.includes('child') || type.includes('infant')) return sum
            return sum + Number(fee.payment_guests || 0)
          }, 0)
        }
      } catch (e) {}

      try {
        const userData = JSON.parse(localStorage.getItem('user_data') || '{}')
        return Number(userData.adults || 0)
      } catch (e) { return 0 }
    },

    getStorageChildren() {
      try {
        const guests = JSON.parse(localStorage.getItem('guests') || '{}')
        if (guests.children !== undefined && guests.children !== null && guests.children !== '') {
          return Number(guests.children || 0)
        }
      } catch (e) {}

      try {
        const conservation = JSON.parse(localStorage.getItem('conservation_data') || '[]')
        if (Array.isArray(conservation) && conservation.length > 0) {
          return conservation.reduce(function (sum, fee) {
            const type = fee.payment_person ? fee.payment_person.toLowerCase() : ''
            if (!type.includes('child')) return sum
            if (type.includes('infant')) return sum
            return sum + Number(fee.payment_guests || 0)
          }, 0)
        }
      } catch (e) {}

      try {
        const userData = JSON.parse(localStorage.getItem('user_data') || '{}')
        return Number(userData.children || 0)
      } catch (e) { return 0 }
    },

    loadGuestsFromStorage() {
      var adults = this.getStorageAdults()
      var children = this.getStorageChildren()

      if ((adults === 0 && children === 0) && this.hasGlobalGuests) {
        adults = this.globalGuests.adults
        children = this.globalGuests.children
      }

      if (adults > 0 || children > 0) {
        this.activity.adults = adults
        this.activity.children = children
      }
    },

    onBookingDatesChanged(dates) {
      if (!dates || !dates.check_in) return
      this.activity.activity_date = dates.check_in
    },

    getResidencyName: function(residency) {
      if (residency && residency.payment_person) {
        return residency.payment_person
      }
      return ''
    },

    openInfo: function(inventory) {
      this.currentInfoInventory = inventory
      this.currentInfoImageIndex = 0
      this.$store.dispatch('get_activity_images', inventory.public_id)
      this.infoDialog = true
    },

    prevInfoImage: function() {
      if (this.currentInfoImageIndex > 0) {
        this.currentInfoImageIndex--
      }
    },

    nextInfoImage: function() {
      if (this.currentInfoImageIndex < this.infoImages.length - 1) {
        this.currentInfoImageIndex++
      }
    },

    openBookingDialog: function(inventory) {
      this.selectedInventory = inventory
      this.resetActivityForm()
      this.$store.commit('REMOVE_AVAILABILITY')

      var storedAdults = this.getStorageAdults()
      var storedChildren = this.getStorageChildren()

      if (storedAdults > 0 || storedChildren > 0) {
        if (!this.selectedInventory.ranger_marker) {
          this.activity.adults = storedAdults
          this.activity.children = storedChildren
        } else {
          this.activity.adults = storedAdults
        }
      } else if (this.hasGlobalGuests) {
        if (!this.selectedInventory.ranger_marker) {
          this.activity.adults = this.globalGuests.adults || 0
          this.activity.children = this.globalGuests.children || 0
        } else {
          this.activity.adults = this.globalGuests.adults || 0
        }
      }

      if (this.hasGlobalBookingDates && !this.activity.activity_date) {
        this.activity.activity_date = this.globalBookingDates.check_in
      }

      this.dialog = true
      this.$store.dispatch('get_activity', inventory.public_id)
      this.$store.dispatch('get_full_conservation_fees')

      if (this.route === 'Reservation') {
        this.$store.dispatch('get_all_pick_up_locations')
      }

      if (this.activity.activity_date && this.selectedInventory) {
        this.$nextTick(() => {
          this.findAvailability()
        })
      }
    },

    findAvailability: function() {
      this.$store.dispatch('loading_true')

      var data = {
        date: this.$moment(this.activity.activity_date).format('YYYY-MM-DD'),
        inventory_id: this.selectedInventory.public_id,
      }
      this.$store.dispatch('check_inventory_availability', data)

      var priceData = {
        date: this.$moment(this.activity.activity_date).format('YYYY-MM-DD'),
        public_id: this.selectedInventory.public_id,
      }
      this.$store.dispatch('get_activity_with_pricing', priceData)

      this.showDates = true
    },

    showNotification: function(type, title, text) {
      if (this.$notify) {
        this.$notify({
          type: type,
          group: 'foo',
          title: title,
          text: text,
          classes: 'alert-wrapper',
        })
      }
    },

    getFirstValidationError() {
      if (!this.activity.activity_date) {
        return { message: 'Please select an activity date.', selector: '.date-input' }
      }
      if (!this.hasParticipants) {
        return { message: 'Please add at least one participant.', selector: '.participant-input' }
      }
      if (this.activity.adults > 0 && !this.hasResidency(this.activity.residency_adult)) {
        return { message: 'Please select adult residency.', selector: '[data-field="residency-adult"]' }
      }
      if (this.activity.children > 0 && !this.hasResidency(this.activity.residency_children)) {
        return { message: 'Please select children residency.', selector: '[data-field="residency-children"]' }
      }
      if (this.activity.extra_pax_adults > 0 && !this.hasResidency(this.activity.residency_extra_adult)) {
        return { message: 'Please select extra adult residency.', selector: '[data-field="residency-extra-adult"]' }
      }
      if (this.activity.extra_pax_children > 0 && !this.hasResidency(this.activity.residency_extra_children)) {
        return { message: 'Please select extra children residency.', selector: '[data-field="residency-extra-children"]' }
      }
      if (this.needsPickupLocation && !this.activity.pick_up_location) {
        return { message: 'Please select a pick up location.', selector: '[data-field="pick-up-location"]' }
      }
      return null
    },

    addToReservationCart: function() {
      const firstError = this.getFirstValidationError()
      if (firstError) {
        this.showNotification('warning', 'Almost there', firstError.message)
        this.$nextTick(() => {
          const el = document.querySelector(firstError.selector)
          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' })
        })
        return
      }

      this.activity.inventory = this.selectedInventory
      this.activity.inventory.price = this.$store.state.ActivityStore.activity_price_at_time
      this.activity.inventory.public_id = this.selectedInventory.public_id

      const cartItem = {
        public_id: this.selectedInventory.public_id,
        name: this.selectedInventory.name,
        date: this.$moment(this.activity.activity_date).format('YYYY-MM-DD'),
        adults: this.activity.adults,
        adult_price: this.selectedInventory.price.adult_price,
        child_price: this.selectedInventory.price.child_price,
        currency: this.selectedInventory.price.currency_type,
        children: this.activity.children,
        ranger_marker: this.selectedInventory.ranger_marker,
        activity_discount: 0,
        discounts: this.selectedInventory.discount || 0,
        discount_status: this.selectedInventory.discount_status || false,
        extra_pax_adults: this.activity.extra_pax_adults,
        extra_pax_children: this.activity.extra_pax_children,
        time_frame: this.activity.time_frame,
        pick_up_location: this.activity.pick_up_location,
        residency_children: this.activity.residency_children,
        residency_adult: this.activity.residency_adult,
        residency_extra_adult: this.activity.residency_extra_adult,
        residency_extra_children: this.activity.residency_extra_children,
      }

      let oldData = JSON.parse(localStorage.getItem('activity_data') || '[]')
      var existingIndex = -1
      for (var i = 0; i < oldData.length; i++) {
        if (oldData[i].public_id === cartItem.public_id && oldData[i].date === cartItem.date) {
          existingIndex = i
          break
        }
      }

      if (existingIndex !== -1) {
        oldData[existingIndex] = cartItem
      } else {
        oldData.push(cartItem)
      }

      localStorage.setItem('activity_data', JSON.stringify(oldData))
      this.$store.commit('CHOSEN_ACTIVITIES', oldData)
      this.$root.$emit('cart-updated')
      this.$emit('activity-added', cartItem)

      this.showNotification('success', 'Activity Added', this.selectedInventory.name + ' has been added to your booking')
      this.closeDialog()
    },

    closeDialog: function() {
      this.dialog = false
      this.resetActivityForm()
      this.$store.commit('REMOVE_AVAILABILITY')
    },

    resetActivityForm: function() {
      this.activity = {
        activity_date: this.hasGlobalBookingDates ? this.globalBookingDates.check_in : '',
        children: 0,
        adults: 0,
        extra_pax_adults: 0,
        extra_pax_children: 0,
        inventory: {},
        time_frame: '',
        pick_up_location: '',
        residency_adult: {},
        residency_children: {},
        residency_extra_adult: {},
        residency_extra_children: {},
      }
      this.showDates = false
    },
  },
}
</script>

<style scoped>
@font-face {
  font-family: 'Earthwerk';
  src: url('PizzaDude.dk-Earthwerk.otf');
  font-weight: normal;
  font-style: normal;
}

.activities-container {
  max-width: 1200px;
  margin: 0 auto;
}

.date-selection-card {
  border-radius: 12px;
  overflow: hidden;
}

.activity-card {
  border-radius: 8px !important;
  transition: all 0.3s ease;
  overflow: hidden;
}

.activity-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important;
}

.activity-image {
  border-radius: 8px 8px 0 0 !important;
  transition: transform 0.5s ease;
  overflow: hidden;
}

.activity-card:hover .activity-image {
  transform: scale(1.05);
}

.image-overlay {
  padding: 16px;
}

.activity-badge {
  background-color: rgba(116, 165, 51, 0.9);
  color: white;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 600;
  display: inline-block;
  margin-bottom: 8px;
}

.activity-note {
  background-color: rgba(52, 152, 219, 0.9);
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  display: block;
  max-width: 100%;
  position: relative;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  line-height: 1.4;
  margin-top: 8px;
  border-left: 3px solid rgba(255, 255, 255, 0.5);
  animation: fadeIn 0.5s ease;
}

.activity-note::before {
  content: '';
  position: absolute;
  top: -8px;
  left: 15px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid rgba(52, 152, 219, 0.9);
}

.earthwerk-font {
  font-family: 'Earthwerk', sans-serif;
  color: #333;
  font-size: 20px;
  line-height: 1.3;
  margin-bottom: 8px;
  letter-spacing: 0.5px;
}

.activity-title {
  transition: color 0.2s ease;
  font-size: 18px;
}

.activity-title:hover {
  color: #74a533 !important;
}

.capacity-display {
  display: flex;
  gap: 20px;
  margin-top: 15px;
}

.capacity-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.capacity-label {
  font-size: 16px;
  color: #666;
}

.capacity-value {
  font-size: 18px;
  font-weight: 600;
  color: #74a533;
}

.earth-color {
  color: #74a533;
}

.info-icon {
  cursor: pointer;
  color: #666;
  margin-left: 10px;
  vertical-align: middle;
}

.info-icon:hover {
  color: #74a533;
}

.book-now-btn {
  width: 100%;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.info-dialog,
.booking-dialog {
  border-radius: 12px !important;
  overflow: hidden;
}

.gallery-section {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  position: relative;
}

.gallery-container,
.single-image-container {
  width: 100%;
  height: 400px;
}

.image-navigation {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  position: relative;
}

.image-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.gallery-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.7);
  border: none;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: all 0.3s ease;
}

.nav-button:hover {
  background: rgba(255, 255, 255, 0.9);
}

.nav-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.nav-button.prev {
  left: 20px;
}

.nav-button.next {
  right: 20px;
}

.image-counter {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 5px 15px;
  border-radius: 20px;
  font-size: 14px;
  z-index: 10;
}

.details-section {
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.details-header {
  margin-bottom: 25px;
  border-bottom: 1px solid #eee;
  padding-bottom: 20px;
}

.description-section {
  color: #555;
  line-height: 1.8;
  font-size: 16px;
  margin-bottom: 30px;
}

.description-section >>> p {
  margin-bottom: 15px;
}

.description-section >>> a {
  color: #74a533;
  text-decoration: none;
}

.description-section >>> a:hover {
  text-decoration: underline;
}

.dialog-header {
  background-color: #74a533;
  color: white;
  padding: 20px 24px;
  display: flex;
  align-items: center;
}

.dialog-header h2 {
  font-family: 'Earthwerk', sans-serif;
  font-size: 24px;
  margin: 0;
}

.progress-chip {
  font-weight: 600;
  letter-spacing: 0.3px;
}

.dialog-content {
  padding: 24px;
}

.date-input {
  margin-bottom: 15px;
}

.participant-input {
  margin-bottom: 15px;
}

.price-summary {
  margin-top: 25px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.price-breakdown {
  margin-top: 10px;
}

.price-line {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
}

.price-total {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 2px solid #74a533;
  font-size: 16px;
}

.requirements-list {
  list-style: none;
  padding-left: 0;
  margin: 8px 0 0 0;
}

.requirements-list li {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 0;
  font-size: 14px;
  color: #555;
}

.dialog-actions {
  padding: 16px 24px;
  border-top: 1px solid #eee;
}

.cancel-btn {
  margin-right: 10px;
}

.reserve-btn {
  font-weight: 600;
  letter-spacing: 0.5px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 960px) {
  .earthwerk-font {
    font-size: 18px;
  }
  .capacity-display {
    flex-direction: column;
    gap: 10px;
  }
  .gallery-container,
  .single-image-container {
    height: 300px;
  }
  .activity-title {
    font-size: 28px;
  }
}

@media (max-width: 600px) {
  .activity-card {
    margin-bottom: 16px;
  }
  .earthwerk-font {
    font-size: 16px;
  }
  .activity-note {
    font-size: 12px;
    padding: 4px 8px;
  }
  .dialog-header h2 {
    font-size: 20px;
  }
  .gallery-container,
  .single-image-container {
    height: 250px;
  }
  .activity-title {
    font-size: 24px;
  }
  .nav-button {
    width: 35px;
    height: 35px;
  }
  .nav-button.prev {
    left: 10px;
  }
  .nav-button.next {
    right: 10px;
  }
  .image-counter {
    font-size: 12px;
    padding: 3px 10px;
  }
}
</style>
<style>
.warning-tooltip {
  background-color: #ff9800 !important;
  color: #ffffff !important;
  font-weight: 600;
  opacity: 1 !important;
  border-radius: 6px;
  padding: 8px 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}
.warning-tooltip::after {
  border-top-color: #ff9800 !important;
}
</style>